import {GET_API_TOKEN_LIST} from './actionTypes'
import { get, post, httpDelete } from 'store/http/httpAction';
import allInfos from 'i18n/global/info';

export const setApiTokenList = (payload) => ({
    type: GET_API_TOKEN_LIST,
    payload: payload
})


export const fetchApiTokenList = () => (dispatch, getState) => 
    get(`/admin/me/oauth/personal-access-tokens`, {}, dispatch).then((data) => {
        if(data){
            dispatch(setApiTokenList(data.data))
        }
    })

export const addApiToken = (objectName) => (dispatch, getState) => 
    post(
        `/admin/me/oauth/personal-access-tokens`, 
        {name: objectName}, 
        dispatch, 
        { successMessage: `${allInfos[window.globalLanguage]['post']}`, callbackAction: null }
    ).then((data) => {
        if(data.token){
            dispatch(fetchApiTokenList())
        }
    })

export const deleteApiToken = (id) => (dispatch, getState) => 
    httpDelete(
        `/admin/me/oauth/personal-access-tokens/${id}`, 
        {}, 
        dispatch, 
        { successMessage: `${allInfos[window.globalLanguage]['httpDelete']}`, callbackAction: null }
    ).then((data) => {
        if(data.msg === "token revoked"){
            dispatch(fetchApiTokenList())
        }
    })


export const updateApiToken = (id, objectName) => (dispatch, getState) =>
    post(`/admin/me/oauth/personal-access-tokens/${id}`,
        {name: objectName}, 
        dispatch, 
        { successMessage: `${allInfos[window.globalLanguage]['patch']}`, callbackAction: null }
    ).then((data) =>{
       if(data.msg === "name updated"){
           dispatch(fetchApiTokenList())
       }
    })


// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/flow/action.js